$(document).ready(function () {
    $(function () {
        $('[data-bs-toggle="popover"]').popover({
            trigger: 'hover',
            html:true
            }
        )
    });
});
